/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;
const SvgChevronDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6.35 8 5 9.739 12 16l7-6.261L17.65 8 12 13.054z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronDown as ChevronDown };
